import {
  ClearOutlined,
  FilterOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import SidePanel from 'components/UI/Responsive/SidePanel';
import { VerticalFormFields } from 'styles/VerticalFormFields';
import { FilterLayoutProps, MainRowColumns, PageFiltersLayout } from './types';

import * as S from './styles';

type Props = FilterLayoutProps & {
  layout: PageFiltersLayout;
  mainRowColumns: MainRowColumns;
  onSearch: () => void;
};

const describeActiveHint = (count: number): string =>
  count === 1 ? '1 filtro avançado ativo' : `${count} filtros avançados ativos`;

export default function PageFilters({
  layout,
  mainRowColumns,
  mainFields,
  advancedFields,
  activeAdvancedCount,
  isAdvancedOpen,
  onToggleAdvanced,
  onClear,
  onSearch,
  onSearchAndClose,
}: Props) {
  const showsActiveHint = activeAdvancedCount > 0 && !isAdvancedOpen;

  return (
    <>
      <S.MainRow data-layout={layout} $columns={mainRowColumns}>
        {mainFields}
        <S.Icons data-layout={layout}>
          <Button
            aria-label="Filtros avançados"
            aria-expanded={isAdvancedOpen}
            onClick={onToggleAdvanced}
            icon={<FilterOutlined aria-hidden />}
          />
          <Button
            aria-label="Limpar filtros"
            onClick={onClear}
            icon={<ClearOutlined aria-hidden />}
          />
          <Button
            aria-label="Buscar"
            type="primary"
            onClick={onSearch}
            icon={<SearchOutlined aria-hidden />}
          />
        </S.Icons>
      </S.MainRow>

      {showsActiveHint && (
        <S.ActiveHint>{describeActiveHint(activeAdvancedCount)}</S.ActiveHint>
      )}

      {layout === 'tablet' ? (
        <SidePanel
          isOpen={isAdvancedOpen}
          onClose={onToggleAdvanced}
          title="Filtros avançados"
          keepMounted
          footer={
            <S.Actions data-even="true">
              <S.ActionButton type="button" onClick={onClear}>
                Limpar filtros
              </S.ActionButton>
              <S.ActionButton
                type="button"
                data-primary="true"
                onClick={onSearchAndClose}
              >
                Buscar
              </S.ActionButton>
            </S.Actions>
          }
        >
          <VerticalFormFields>
            <S.PanelFields>{advancedFields}</S.PanelFields>
          </VerticalFormFields>
        </SidePanel>
      ) : (
        <S.AdvancedBox aria-label="Filtros avançados" hidden={!isAdvancedOpen}>
          {advancedFields}
        </S.AdvancedBox>
      )}
    </>
  );
}
